/**
 * Converts absolute size in pixels into relative one. 
 * @param size1080px 
 */
export const r = (size1080px: number): string => `${rNum(size1080px)}vh`;

const rNum = (size1080px: number): number => 100.0 * size1080px / 1080.0;